import { useMemo } from "react"
import { createDeferredPromise } from "@/lib/helpers/promises"

export const useDeferredPromise = <T>() => {
  return useMemo(() => createDeferredPromise<T>(), [])
}
